<div class="flex flex-col bg-navy-900 h-full">
  <div class="flex-1 bg-slate-50 overflow-hidden flex">
    <!-- Sub-nav -->
    <aside
      [ngClass]="mobileView() === 'list' ? 'flex' : 'hidden'"
      class="w-full md:flex md:w-73 shrink-0 bg-surface-200 border-r border-slate-100 flex-col py-8.5 px-3"
    >
      <p class="text-2xs font-semibold text-slate-400 uppercase tracking-widest px-3 mb-4">
        Administration
      </p>

      <nav class="space-y-1">
        @for (item of subNavItems; track item.route) {
          <a
            [routerLink]="item.route"
            routerLinkActive="bg-white"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="onNavClick()"
            class="flex items-start gap-3 px-3 py-3 rounded-2xl hover:bg-slate-50 transition-colors cursor-pointer h-18"
          >
            <img
              [src]="'icons/' + item.icon + '-icon.svg'"
              [alt]="item.label"
              class="w-5 h-5 shrink-0 mt-0.5"
            />
            <div class="flex flex-col min-w-0">
              <span class="text-xs text-navy-800 font-semibold leading-5 truncate">{{
                item.label
              }}</span>
              <span class="text-2xs text-slate-500 mt-0.5 leading-4">{{ item.description }}</span>
            </div>
          </a>
        }
      </nav>
    </aside>

    <!-- Content -->
    <div
      [ngClass]="mobileView() === 'content' ? 'flex' : 'hidden'"
      class="md:flex flex-col flex-1 overflow-auto"
    >
      <!-- Mobile back button -->
      <div class="md:hidden flex items-center gap-2 px-4 py-3 border-b border-slate-100 bg-white">
        <button
          type="button"
          (click)="goBack()"
          class="flex items-center gap-1.5 text-xs font-semibold text-navy-600 cursor-pointer"
        >
          <img src="/icons/chevron-left-icon.svg" class="w-4 h-4" alt="" />
          Configuration
        </button>
      </div>

      <router-outlet />
    </div>
  </div>
</div>
